// You'd ADD these imports at the top:
import { ThemeBus } from './events-bus.js';
import { EVENTS } from './event-constants.js';

class CartShippingBar extends HTMLElement {
  connectedCallback() {
    // You'd ADD: Get references to DOM elements you want to update
    this.progressBar = this.querySelector('progress');
    this.amountSpan = this.querySelector('[ref="cartTargetAmount"]');
    this.label = this.querySelector('label');
    
    this.threshold = parseInt(this.dataset.threshold) || 0; // from settings (in cents)
    this.successMessage = this.dataset.success || '';
    this.originalLabelHTML = this.label.innerHTML; // Store original label content
    
    // Initial load
    this.#fetchAndUpdate();
    
    // Listen for updates
    ThemeBus.addEventListener(EVENTS.cartUpdated, this.#fetchAndUpdate);
  }
  
  #fetchAndUpdate = async () => {
    let cart;
    if (window.__cart && window.__cart.total_price !== undefined) {
      cart = window.__cart;
    } else {
      cart = await fetch('/cart.js').then(r => r.json());
    }
    
    const currentTotal = cart.total_price; // in cents
    const remaining = Math.max(0, this.threshold - currentTotal);
    const percentage = Math.min(100, (currentTotal / this.threshold) * 100);
    
    this.#updateBar(percentage, remaining, currentTotal);
  }
  
  #updateBar(percentage, remaining, currentTotal) {
    this.progressBar.value = percentage;
    
    if (currentTotal >= this.threshold) {
      this.label.textContent = this.successMessage;
      this.progressBar.value = 100;
    } else {
      // Restore original label with updated amount
      this.label.innerHTML = this.originalLabelHTML;
      this.amountSpan = this.querySelector('[ref="cartTargetAmount"]');
      const remainingFormatted = this.#formatMoney(remaining);
      this.amountSpan.textContent = remainingFormatted;
    }
  }
  
  // Helper to format money
  #formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const amountWithComma = amount.replace('.', ',');
    const amountNoDecimals = Math.round(cents / 100).toString();
    const amountNoDecimalsWithComma = amountNoDecimals.replace('.', ',');
    
    let format = window.theme?.moneyFormat || '${{amount}}';
    
    // Replace all Shopify money format placeholders
    format = format
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_space_separator}}', amount.replace('.', ' '))
      .replace('{{amount}}', amount);
    
    return format;
  }
  
  disconnectedCallback() {
    // You'd ADD: Clean up listener
    ThemeBus.removeEventListener(EVENTS.cartUpdated, this.#fetchAndUpdate);
  }
}

// You'd ADD: Register the custom element
customElements.define('cart-shipping-bar', CartShippingBar);